module.exports = __webpack_public_path__ + "img/about-banner.e47cb5ba.webp";